module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "vexth"
  }, [_vm._v("THE MOON LOOKS DOWN")]), _vm._v(" "), _c('p', {
    staticClass: "vext1"
  }, [_vm._v("I climb alone to my secret place")]), _vm._v(" "), _c('p', {
    staticClass: "vext"
  }, [_vm._v("And gaze from my rocky perch")]), _vm._v(" "), _c('p', {
    staticClass: "vext3"
  }, [_vm._v("To commune with the moon.")]), _vm._v(" "), _c('p', {
    staticClass: "vext1"
  }, [_vm._v("I ask that circling silvery stone the")]), _vm._v(" "), _c('p', {
    staticClass: "vext"
  }, [_vm._v("Questions that perplex me so.")]), _vm._v(" "), _c('p', {
    staticClass: "vext3"
  }, [_vm._v("Can the moon on high tell me why…")]), _vm._v(" "), _c('p', {
    staticClass: "vext1"
  }, [_vm._v("Why dark souls aflame with hate")]), _vm._v(" "), _c('p', {
    staticClass: "vext"
  }, [_vm._v("Ignite the fires that terrify me,")]), _vm._v(" "), _c('p', {
    staticClass: "vext"
  }, [_vm._v("Why those whom once I trusted")]), _vm._v(" "), _c('p', {
    staticClass: "vext3"
  }, [_vm._v("Plot to harm the ones I love.")]), _vm._v(" "), _c('p', {
    staticClass: "vext1"
  }, [_vm._v("I look with hope into the night")]), _vm._v(" "), _c('p', {
    staticClass: "vext"
  }, [_vm._v("And the moon looks down.")]), _vm._v(" "), _c('p', {
    staticClass: "vext"
  }, [_vm._v("How absurd! It says not a word.")]), _vm._v(" "), _c('p', {
    staticClass: "vexts"
  }, [_vm._v("—F.S.I.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37107bae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MoonLookedDown_epig-1.vue
// module id = 72
// module chunks = 0